<template>
  <v-treeview
    dense
    :active.sync="active"
    :open.sync="open"
    :items="nodes"
    :load-children="fetchChildren"
    activatable
    return-object
    color="warning"
    transition
    item-key="NODE_ID"
    item-text="NODE_NAME"
  >
    <template v-slot:prepend="{ item }">
      <v-icon v-if="item.isUser">
        mdi-account
      </v-icon>
      <v-icon v-else>
        mdi-account-group
      </v-icon>
    </template>
    <template v-slot:label="{ item }">
      <span style="cursor: pointer">{{item.NODE_NAME}}</span>
    </template>
  </v-treeview>
</template>

<script>
import { UI_SNACKBAR } from '@/store/actions/ui'
import { ORG_GET_STRUCTURE, ORG_CLEAR_STRUCTURE, ORG_SET_DIVISION, ORG_SET_USER } from '@/store/actions/org'
import { findParent } from '@/libs/treeUtils.js'

export default {
  props: ['org'],
  data () {
    return {
      active: [],
      open: []
    }
  },
  computed: {
    nodes: {
      get: function () {
        return this.$store.getters.getStructure
      }
    },
    userRole: {
      get: function () {
        return this.$store.getters.getUserRole
      }
    },
    selected: {
      get: function () {
        if (!this.active.length) return undefined
        return this.active[0]
      }
    },
    currentDivNode: {
      get: function () {
        return this.$store.getters.getCurrentDivNode
      }
    }
  },
  watch: {
    selected: 'onSelected',
    org (val) {
      console.log('TreeView component: org changed ', val)
      if (val) {
        this.$store.dispatch(ORG_GET_STRUCTURE, { INST_UUID: val.INST_UUID, NODE_ID: 0, PARENT_ID: -1 })
          .catch((err) => {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка получения данных' + err })
            console.log(err)
          })
      }
      this.$store.commit(ORG_SET_USER, {})
    }
  },
  methods: {
    async fetchChildren (item) {
      await
      this.$store.dispatch(
        ORG_GET_STRUCTURE, item)
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка получения данных' + err })
          console.log(err)
        })
    },
    async setActive (data) {
      console.log('Called setActive node', data)
      await this.setCurrentUser(data)
    },
    async setActiveNode (data) {
      console.log('Called setActiveNode', data)
      await this.setCurrentNode(data)
    },
    async setOpen (node) {
      console.log('Called set open node', node)
      await this.setCurrentOpen(node)
    },
    async addChild (data) {
      console.log('Called addChild node', data)
      await this.updCurrentDivision(data)
    },
    setCurrentUser (nodeID) {
      console.log('Getting ...', this.currentDivNode)
      const node = this.currentDivNode.children.find(itm => itm.EMP_ID === nodeID)
      if (node) {
        this.active.splice(0, 1, node)
        this.setOpen(this.currentDivNode)
      }
    },
    updCurrentDivision (nodeID) {
      console.log('Getting ...', this.currentDivNode)
      const node = this.currentDivNode.children.find(itm => itm.NODE_ID === nodeID)
      if (node) {
        this.active.splice(0, 1, node)
        this.setOpen(this.currentDivNode)
      }
    },
    setCurrentOpen (node) {
      const opn = this.open.find(item => item.NODE_ID === node.NODE_ID)
      if (!opn) {
        this.open.push(node)
      }
    },
    setCurrentNode (node) {
      this.active.splice(0, 1, node)
    },
    omitObjectCopy (obj, props) {
      props = props instanceof Array ? props : [props]
      // eslint-disable-next-line no-eval
      return eval(`(({${props.join(',')}, ...o}) => o)(obj)`)
    },
    onSelected (val) {
      let parent = null
      let result = val
      console.log('onSelected handler called, ', val)
      if (val) {
        console.log('onSelected handler val defined')
        if (val.isUser) {
          console.log('onSelected handler val is user')
          const root = findParent(this.nodes[0], val.PARENT_ID)
          if (root) {
            parent = root
          } else {
            console.log('Parent not found for ', val.PARENT_ID)
          }
          result = this.omitObjectCopy(val, ['NODE_ID', 'NODE_NAME', 'PARENT_ID', 'isUser'])
          this.$store.commit(ORG_SET_USER, result)
          this.$store.commit(ORG_SET_DIVISION, parent || {})
          this.$emit('input', result)
          return
        } else {
          console.log('onSelected handler val is division')
          this.$store.commit(ORG_SET_DIVISION, result)
          this.$store.commit(ORG_SET_USER, {})
          this.$emit('input', result)
          return
        }
      }
      console.log('onSelected handler val is empty')
      this.$store.commit(ORG_SET_DIVISION, {})
      this.$store.commit(ORG_SET_USER, {})
      this.$emit('input', result)
    }
  },
  mounted: function () {
    console.log('Organization tree component mounted, for org', this.org)
    this.$store.dispatch(ORG_GET_STRUCTURE, { INST_UUID: this.org ? this.org.INST_UUID : undefined, NODE_ID: 0, PARENT_ID: -1 })
      .catch((err) => {
        this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: 'Ошибка получения данных' + err })
        console.log(err)
      })
      .finally(() => {
        this.$store.commit(ORG_SET_USER, {})
      })
  },
  destroyed: function () {
    this.$store.commit(ORG_CLEAR_STRUCTURE)
    console.log('TreeView component destroyed')
  }
}
</script>
